import { getOverviewLifetimePcConsole } from '@/pages/opinion/services';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { DBO_TM } from '@op/utils/format';
import _ from 'lodash-es';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';

export function useRequestLifetimePcConsole({ filter }: any) {
  const [startTime, endTime, isToday] = useMemo(() => {
    const startTime = moment(filter?.start_time).format('YYYY-MM-DD');
    const endTime = moment(filter?.end_time).format('YYYY-MM-DD');
    const is_today = DBO_TM.isToday(filter);

    return [startTime, endTime, is_today];
  }, [filter]);

  const [loading, setLoading] = useState<boolean>(false);
  const [time, setTime] = useState({
    metacritic: '',
    opencritic: '',
    steam: '',
  });

  const [show, setShow] = useState({
    metacritic: false,
    opencritic: false,
    steam: false,
  });
  const [data, setData] = useState<any>({});

  const changeTime = (value: string, key: string) => {
    setTime({ ...time, [key]: value });
    setShow({ ...show, [key]: true });
  };

  const getConsolePcGameStoreData = () => {
    setLoading(true);
    setTime({ metacritic: '', opencritic: '', steam: '' });
    setShow({ metacritic: false, opencritic: false, steam: false });
    getOverviewLifetimePcConsole({
      ...filter,
      is_today: isToday,
    })
      .then((data: any) => {
        const dataList = data || [];
        const timeMap: any = { ...time };
        const dataMap = arrayToSimpleObj(dataList, 'list', item => {
          timeMap[item.channel] = item.has_date_time;
          return item.channel;
        });
        setData(dataMap);
        // 全平台都可以添加时间
        if (isToday) {
          return setTime(timeMap);
        }
        // 查看那个平台是有数据的
        const timeObj: any = {};
        _.forOwn(
          dataMap,
          (element: { is_last_time_data: any }[], key: string | number) => {
            if (
              element?.some(
                (item: { is_last_time_data: any }) => !item.is_last_time_data,
              )
            ) {
              timeObj[key] = timeMap[key];
            }
          },
        );

        setTime(timeObj);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (filter.edition_unified_id) {
      getConsolePcGameStoreData();
    }
  }, [filter]);

  return {
    changeTime,
    loading,
    data,
    show,
    time,
    isToday,
    startTime,
    endTime,
  };
}
